/**
 * Reczne sledzenie pozycji (Faza 1): atrapa bez mikrofonu i bez sieci.
 * Gitarzysta dotyka brzegu ekranu, zeby przesunac podswietlenie na
 * sasiednia sekcje. Ten modul liczy tylko docelowy indeks, stan
 * (`aktywnaSekcja: number | null`) zyje w `main.ts`.
 */
export interface StanPozycji {
  /** Indeks aktywnej sekcji w `variant.sections`. */
  indeks: number;
  /** Liczba sekcji utworu. */
  liczbaSekcji: number;
}

/** Nastepna sekcja, przypieta do ostatniej (bez zawijania na poczatek). */
export function nastepna(stan: StanPozycji): number {
  return Math.min(stan.indeks + 1, stan.liczbaSekcji - 1);
}

/** Poprzednia sekcja, przypieta do pierwszej (bez zawijania na koniec). */
export function poprzednia(stan: StanPozycji): number {
  return Math.max(stan.indeks - 1, 0);
}
